import { useUser } from '@providers/User';
import { VtaasRole } from '@providers/User/vtaasRole';

export function useUserHasRole(roles: VtaasRole[]) {
  const user = useUser();
  const { role } = user;
  return roles.some((r) => role?.includes(r));
}
